import './styles.css';
import { Col, Row, Form, Button, Select, Upload } from 'antd';
import ContainerFluid from 'app/components/Layout/ContainerFluid';
import { LoadingContainer } from 'app/components/LoadingContainer/Loadable';
import { useDispatch, useSelector } from 'react-redux';
import { memo, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { TGroupRepresentative } from './types';
import { POSITION } from './constants';
import { CheckoutOrderOverview } from './OrderOverview';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import {
  selectBusinessPartner,
  selectInfoUser,
  selectTranslations,
} from '../App/slice/selectors';
import { GET_BUSINESS_PARTNER } from '../App/slice';
import { createNewOrderApi } from 'app/services/checkoutApi';
import { useHistory } from 'react-router-dom';
import React from 'react';
import { CheckoutWrapper } from '../Checkout/styled';
import {
  AddFieldContainer,
  CustomSelect,
  Description,
  FormContainer,
  HeaderContainer,
  Title,
} from './styled';
import CustomInput from './components/ImputCustom';
import _ from 'lodash';
import PlusIcon from './icon/PlusIcon';
import { selectGetListTicketForms } from '../Catalog/slice/selectors';
import useWindowSize from 'app/hooks/useWindowSize';
import { useGlobalFunction } from '../App/hooks/useGlobalFunction';
import { AddonsTicketModal } from 'app/components/AddonsTicketModal';
import { getPriceCartApi, getTicketAddons } from 'app/services/showApi';
import moment from 'moment';
import useFetchData from 'app/hooks/useFetchData';
import { getBusinessPartnerApi } from 'app/services/agentApi';
import { BP_TYPE } from 'utils/constants';
import styled from 'styled-components';
import { convertVItoEN } from '../NewAccount/CheckTickets/helper';
import {
  clearOrderSession,
  clearOrderSubmitted,
  hasOrderSession,
  getOrderRequestId,
  getOrderTicketType,
  hasPendingOrderSubmit,
  markOrderSubmitted,
  ORDER_ITEMS_KEY,
} from 'utils/orderRequestId';
const { Option } = Select;

export const UnionRepresentative = memo(() => {
  const [hasSession] = useState(hasOrderSession);
  const history = useHistory();

  useEffect(() => {
    if (!hasSession) history.replace('/catalog');
  }, [hasSession, history]);

  if (!hasSession) return null;
  return <UnionRepresentativeForm />;
});

const UnionRepresentativeForm = memo(() => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { executeRecaptcha } = useGoogleReCaptcha();
  const { data: businessPartnerData } = useSelector(selectBusinessPartner);
  const translations = useSelector(selectTranslations);
  let listTicketFormReducer = useSelector(selectGetListTicketForms);
  const { device } = useWindowSize();
  const { onOpenDialogNoti, onCloseDialogNoti } = useGlobalFunction();
  const [form] = Form.useForm();
  const [requireFields, setRequireFields] = useState<boolean[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isShowAddonsModal, setIsShowAddonsModal] = useState<boolean>(true);
  const [shouldShowAddonsModal, setShouldShowAddonsModal] =
    useState<boolean>(false);
  const [listItems, setListItems] = useState(
    JSON.parse(sessionStorage.getItem(ORDER_ITEMS_KEY) as string),
  );
  const [listAddons, setListAddons] = useState<any>([]);
  const debounceTimeout = useRef<Record<string, NodeJS.Timeout>>({});
  const [isAddonsLoading, setIsAddonsLoading] = useState<boolean>(false);
  const [disableSubmit, setDisableSubmit] = useState<boolean>(false);
  const dataSubmit = JSON.parse(sessionStorage.getItem('dataTemp') as string);
  const [dateAddons, setDateAddons] = useState<string>(
    moment().format('YYYY-MM-DD'),
  );
  const bpAllocatedDebt = dataSubmit?.[0]?.allocatedDebt;

  const getPrice = useCallback(
    async (
      params: {
        date: string;
        show_id: string;
        amount: string;
      },
      ticketData?: any,
    ) => {
      try {
        setIsAddonsLoading(true);
        const formData = new FormData();
        Object.entries(params).forEach(([key, value]) => {
          if (value !== undefined && value !== null) {
            formData.append(`items[0][${key}]`, value);
          }
        });
        if (bpAllocatedDebt !== null && bpAllocatedDebt !== undefined)
          formData.append('items[0][bpAllocatedDebt]', bpAllocatedDebt);
        formData.append('items[0][payment]', dataSubmit[0].payment);
        const orderTicketType = getOrderTicketType();
        if (orderTicketType)
          formData.append('forceTicketType', orderTicketType);
        const res = await getPriceCartApi(formData);
        if (res?.data?.[0]?.error) {
          setListAddons(prev => {
            return [...prev].map(item => {
              if (item?.id === ticketData?.id) {
                return {
                  ...item,
                  error: res?.data?.[0]?.error?.message,
                };
              }
              return item;
            });
          });
          return;
        }

        if (res?.data?.[0]?.errorTicket) {
          setListAddons(prev => {
            return [...prev].map(item => {
              if (item?.id === ticketData?.id) {
                return {
                  ...item,
                  error: res?.data?.[0]?.errorTicket,
                };
              }
              return item;
            });
          });
          return;
        }

        if (
          res?.status === 200 &&
          _.isArray(res?.data) &&
          res?.data?.length > 0
        ) {
          const dataInventory = res?.data[0];
          setListAddons(prev => {
            return [...prev].map(item => {
              if (item?.id === ticketData?.id) {
                return {
                  ...item,
                  price: +dataInventory?.price,
                  inventory: +dataInventory?.inventory,
                  date: dateAddons,
                  displayPrice:
                    +item?.amount > 0
                      ? +dataInventory?.price * item?.amount
                      : '0',
                };
              }
              return item;
            });
          });
          return;
        }
      } catch (err: any) {
        setListAddons(prev => {
          return [...prev].map(item => {
            if (item?.id === ticketData?.id) {
              return {
                ...item,
                error: err?.message,
              };
            }
            return item;
          });
        });
        return;
      } finally {
        setIsAddonsLoading(false);
        setDisableSubmit(false);
      }
    },
    [dataSubmit, dateAddons],
  );

  const fetchAddons = async () => {
    try {
      setIsLoading(true);
      setIsAddonsLoading(true);
      const {
        data: { data: res },
      } = await getTicketAddons({
        showIds: listItems
          .map(item => item?.id || item?.show?.id)
          .join(',') as any,
      });

      const validAddons = res
        ? res.filter(
            (item: any) =>
              !dataSubmit.find(
                submitItem =>
                  submitItem?.show_id === item.id ||
                  submitItem?.show_id === item?.show?.id,
              ),
          )
        : [];

      if (validAddons?.length === 0) {
        setShouldShowAddonsModal(false);
        return;
      } else {
        setIsLoading(false);
        setShouldShowAddonsModal(true);
      }

      setListAddons(
        validAddons.map(item => {
          return {
            ...item,
            amount: '0',
            date: dateAddons,
            displayPrice: '0',
          };
        }),
      );

      await Promise.all(
        [...validAddons].map((item: any) => {
          return getPrice(
            {
              date: dateAddons,
              show_id: item?.id,
              amount: item?.amount || 1,
            },
            {
              ...item,
            },
          );
        }),
      );
    } catch (err: any) {
      onOpenDialogNoti({
        type: 'ERROR',
        isShow: true,
        title: '',
        content:
          err?.data?.dataRequest?.[0]?.message ||
          err?.message.replaceAll('\\n', ''),
        closable: false,
        buttons: [
          {
            text: translations ? translations['b2c.txt.confirm'] : '',
            bg: 'linear-gradient(79.97deg, #F06F24 -7.79%, #F8B117 107.61%)',
            color: 'white',
            onClick: () => {
              onCloseDialogNoti();
            },
          },
        ],
      });
    } finally {
      setIsLoading(false);
      setIsAddonsLoading(false);
    }
  };
  const userInfo = useSelector(selectInfoUser);
  const isProxyBuyer =
    (userInfo?.businessPartner as any)?.bpType === BP_TYPE.PROXY_BUYER;

  const getAllocatedDebtPayload = useMemo(() => {
    return { bpAllocatedDebt };
  }, [bpAllocatedDebt]);

  const { result: allocatedDebtData } = useFetchData({
    actionApi: getBusinessPartnerApi,
    payloadData: getAllocatedDebtPayload,
    IIFE: !!bpAllocatedDebt,
  });

  const businessPartner = !!bpAllocatedDebt
    ? allocatedDebtData
    : businessPartnerData;

  const mailReceiveTicketListOfBpAllocatedDebt = useMemo(
    () => [
      ...new Set([
        ...(allocatedDebtData?.emailAgents ?? []),
        ...(allocatedDebtData?.extraInfo?.email ?? []),
      ]),
    ],
    [allocatedDebtData?.emailAgents, allocatedDebtData?.extraInfo?.email],
  );

  const isNoEmptyAllocatedDebt =
    mailReceiveTicketListOfBpAllocatedDebt.length > 0;

  const mailReceiveTicketList = useMemo(() => {
    if (!bpAllocatedDebt) return [];
    if (isNoEmptyAllocatedDebt) return mailReceiveTicketListOfBpAllocatedDebt;
    return [userInfo?.username];
  }, [
    bpAllocatedDebt,
    isNoEmptyAllocatedDebt,
    mailReceiveTicketListOfBpAllocatedDebt,
    userInfo?.username,
  ]);

  const handleValuesChange = (_, allValues) => {
    if (!Array.isArray(allValues.representatives)) return;

    setRequireFields(
      allValues.representatives.map(rep =>
        Object.values(rep).some(value => value),
      ),
    );
  };

  useEffect(() => {
    dispatch(GET_BUSINESS_PARTNER());
    fetchAddons();
  }, [dispatch]);

  useEffect(() => {
    return () => {
      clearOrderSession();
    };
  }, []);

  const currentEmails =
    _.isEmpty(businessPartner?.extraInfo?.email) ||
    !_.isArray(businessPartner?.extraInfo?.email)
      ? []
      : businessPartner?.extraInfo?.email.map((ele: string) => ele);

  const resetTimeout = useCallback(
    (addonTicket, event?: any) => {
      if (debounceTimeout.current?.[addonTicket?.id as string]) {
        clearTimeout(debounceTimeout.current?.[addonTicket?.id as string]);
      }
      debounceTimeout.current[addonTicket?.id as string] = setTimeout(() => {
        getPrice(
          {
            date: dateAddons,
            show_id: addonTicket?.id,
            amount: addonTicket?.amount,
          },
          {
            ...addonTicket,
            event,
          },
        );
      }, 500);
    },
    [dateAddons, getPrice],
  );

  const handleChangeAddonsAmount = useCallback(
    (value, id, validByJumpValue, event) => {
      setDisableSubmit(true);
      let updatedAddons = [...listAddons];
      updatedAddons = updatedAddons.map(item =>
        item?.id === id
          ? {
              ...item,
              error: null,
            }
          : item,
      );
      setListAddons(updatedAddons);

      const addonTicket = listAddons.find(item => item.id === id);

      if (!validByJumpValue && value >= addonTicket?.minAmountB2b) {
        updatedAddons = updatedAddons.map(item =>
          item.id === id
            ? {
                ...item,
                error: translations?.['b2b.txt.onlyAmount']?.replace(
                  '${jumpValue}',
                  item?.jumpValueB2b,
                ),
              }
            : item,
        );
        setListAddons(updatedAddons);
        setDisableSubmit(false);
        return;
      }

      if (
        value === undefined ||
        value === null ||
        (!validByJumpValue && value >= addonTicket?.jumpValueB2b)
      ) {
        setDisableSubmit(false);
        return;
      }

      if (
        addonTicket?.minAmountB2b &&
        value < addonTicket?.minAmountB2b &&
        value > 0
      ) {
        updatedAddons = updatedAddons.map(item =>
          item.id === id
            ? {
                ...item,
                error: translations?.['b2b.txt.minAmount']?.replace(
                  '${amount}',
                  addonTicket?.minAmountB2b,
                ),
              }
            : item,
        );
        setListAddons(updatedAddons);
        setDisableSubmit(false);
        return;
      }

      updatedAddons = updatedAddons.map(item =>
        item.id === id
          ? {
              ...item,
              amount: value,
            }
          : item,
      );

      event === 'blur' &&
        (validByJumpValue || value === 0) &&
        resetTimeout(
          updatedAddons.find(item => item.id === id),
          event,
        );

      setListAddons(updatedAddons);
    },
    [listAddons, resetTimeout, translations],
  );

  const handleAdd = useCallback(() => {
    setListItems(prev => {
      return [...prev, ...listAddons.filter(item => item?.amount > 0)];
    });
    setIsShowAddonsModal(false);
  }, [listAddons]);

  const handleChangeDate = useCallback(
    async value => {
      setListAddons(prev => {
        return [...prev].map(item => {
          return {
            ...item,
            error: null,
            amount: 0,
          };
        });
      });
      setDateAddons(moment(value).format('YYYY-MM-DD'));
      await Promise.all(
        [...listAddons].map((item: any) => {
          return getPrice(
            {
              date: moment(value).format('YYYY-MM-DD'),
              show_id: item?.id,
              amount: item?.amount,
            },
            {
              ...item,
            },
          );
        }),
      );
    },
    [listAddons, getPrice],
  );

  const onSubmit = async (values: any) => {
    if (hasPendingOrderSubmit()) {
      onOpenDialogNoti({
        type: 'ERROR',
        isShow: true,
        title: '',
        content: translations?.['b2b.txt.orderMayExist'],
        closable: false,
        buttons: [
          {
            text: translations?.['b2c.txt.confirm'] ?? '',
            bg: 'linear-gradient(79.97deg, #F06F24 -7.79%, #F8B117 107.61%)',
            color: 'white',
            onClick: () => {
              onCloseDialogNoti();
            },
          },
        ],
      });
      return;
    }

    setIsLoading(true);

    // const findEVoucher = listTicketFormReducer.find(
    //   (item: any) => _.isEmpty(item?.code) || item?.id === 27964,
    // );
    // console.log('findEVoucher', findEVoucher, listTicketFormReducer);

    if (!executeRecaptcha) return;
    const tokenCaptcha = await executeRecaptcha('createOrder');

    // requestId của giỏ hàng hiện tại. Giữ nguyên qua F5 / retry, chỉ đổi khi
    // user dựng giỏ mới. BE không lưu id này — chống trùng nằm hết ở FE.
    const requestId = getOrderRequestId();
    markOrderSubmitted(requestId);

    const formData = new FormData();
    formData.append('captcha', tokenCaptcha);
    formData.append('requestId', requestId);
    const orderTicketType = getOrderTicketType();
    if (orderTicketType) formData.append('forceTicketType', orderTicketType);
    values.emails
      .filter(ele => !(currentEmails || []).includes(ele))
      .forEach((email: string, index: number) => {
        formData.append(`emailTax[${index}]`, email);
      });

    values?.representatives?.forEach(
      (rep: TGroupRepresentative, index: number) => {
        if (requireFields[index]) {
          formData.append(`representatives[${index}][name]`, rep.name);
          formData.append(`representatives[${index}][phone]`, rep.phone);
          formData.append(`representatives[${index}][email]`, rep.email);
          formData.append(`representatives[${index}][position]`, rep.position);
        }
      },
    );
    formData.append('payment_method', dataSubmit?.[0]?.payment);
    !!dataSubmit?.[0]?.event &&
      formData.append('event', dataSubmit?.[0]?.event);
    if (!_.isNil(values?.['approvedCode']) && values?.['approvedCode'] !== '')
      formData.append('approvedCode', values?.['approvedCode']);
    if (bpAllocatedDebt !== null && bpAllocatedDebt !== undefined)
      formData.append('bpAllocatedDebt', bpAllocatedDebt);
    if (values?.emailBpAllocatedDebt)
      formData.append('emailBpAllocatedDebt', values?.emailBpAllocatedDebt);
    formData.append('deliver_ticket_id', dataSubmit?.[0]?.deliver_ticket_id);
    if (!!values?.approveAttach?.file)
      formData.append('approveAttach', values?.approveAttach?.file);
    const addonsDataSubmit: any = [...dataSubmit];
    if (listItems.length > dataSubmit.length) {
      listAddons.forEach(item => {
        item?.amount > 0 &&
          addonsDataSubmit.push({
            show_id: item?.id,
            amount: item?.amount.toString(),
            date: item?.date,
          });
      });
    }
    addonsDataSubmit.forEach((obj, index) => {
      for (let key in obj) {
        if (key === 'payment') {
          continue;
        }
        if (key === 'event') {
          continue;
        }
        if (obj[key] !== null && obj[key] !== undefined) {
          formData.append(`items[${index}][${key}]`, obj[key]);
        }
      }
    });
    try {
      const { data } = await createNewOrderApi(formData);
      if (data) {
        clearOrderSession();
        history.push('/checkout/' + data.idHash);
      }
    } catch (err: any) {
      const beMayHaveReceived = !!err?.isAxiosError && !err?.response;
      if (!beMayHaveReceived) clearOrderSubmitted();
      let errContent;
      if (
        err?.message === 'errorTicket' &&
        err?.data?.errorType === 'errorTicket' &&
        listItems?.length > 0
      ) {
        errContent = translations?.['b2b.txt.invalidTicket'] ?? '';
      } else {
        errContent =
          err?.data?.dataRequest?.[0]?.message ||
          err?.message.replaceAll('\\n', '');
      }
      onOpenDialogNoti({
        type: 'ERROR',
        isShow: true,
        title: '',
        content: errContent,
        closable: false,
        buttons: [
          {
            text: translations ? translations['b2c.txt.confirm'] : '',
            bg: 'linear-gradient(79.97deg, #F06F24 -7.79%, #F8B117 107.61%)',
            color: 'white',
            onClick: () => {
              onCloseDialogNoti();
            },
          },
        ],
      });
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    if (businessPartner) {
      form.setFieldsValue({
        emails: currentEmails,
        representatives: [
          // { name: "", phone: "", email: "", position: null },
        ],
      });
    }
  }, [businessPartner, form]);

  useEffect(() => {
    form.setFieldValue(
      'emailBpAllocatedDebt',
      isNoEmptyAllocatedDebt ? null : userInfo?.username,
    );
  }, [form, isNoEmptyAllocatedDebt, userInfo?.username]);

  const beforeUploadApprovalDocs = (file: File) => {
    const allowedTypes = [
      'application/pdf',
      'application/msword', // .doc
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
      'application/vnd.ms-excel', // .xls
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
      'message/rfc822', // .eml
    ];

    if (!allowedTypes.includes(file.type)) {
      onOpenDialogNoti({
        type: 'ERROR',
        title: translations?.['b2b.txt.uploadApprovalDocumentType'] ?? '',
        content: '',
        isShow: true,
        buttons: [],
        maskClosable: false,
        closable: true,
        onCloseDialog: onCloseDialogNoti,
      });
      return Upload.LIST_IGNORE;
    }

    if (file.size / 1024 / 1024 > 5) {
      onOpenDialogNoti({
        type: 'ERROR',
        title: translations?.['b2b.txt.uploadApprovalDocumentSize'] ?? '',
        content: '',
        isShow: true,
        buttons: [],
        maskClosable: false,
        closable: true,
        onCloseDialog: onCloseDialogNoti,
      });
      return Upload.LIST_IGNORE;
    }

    return false;
  };

  return (
    <CheckoutWrapper id="bookticketspay" className="main">
      <div className="bookticketspayContent bookticketsContent checkOut">
        <div className="container">
          <LoadingContainer isFullPage loading={isLoading}>
            <Form
              form={form}
              onValuesChange={handleValuesChange}
              onFinish={onSubmit}
              initialValues={{
                emails: currentEmails,
                representatives: [
                  {
                    name: '',
                    phone: '',
                    email: '',
                    position: null,
                  },
                ],
              }}
              validateMessages={{
                required:
                  '${label} ' +
                  (translations
                    ? translations['b2b.form.validate-require']
                    : ''),
                string: {
                  len: '${label} phải có ${len} kí tự',
                  min:
                    '${label} ' +
                    (translations
                      ? translations['b2b.form.validate-min-chars-1']
                      : '') +
                    ' ${min} ' +
                    (translations
                      ? translations['b2b.form.validate-chars']
                      : ''),
                  max:
                    '${label} ' +
                    (translations
                      ? translations['b2b.form.validate-max-chars-1']
                      : '') +
                    ' ${max} ' +
                    (translations
                      ? translations['b2b.form.validate-chars']
                      : ''),
                  range: '${label} must be between ${min} and ${max} kí tự',
                },
                types: {
                  email:
                    '${label} ' +
                    (translations ? translations['b2b.form.invalid'] : ''),
                  number:
                    '${label}: ${type} ' +
                    (translations ? translations['b2b.form.invalid'] : ''),
                  string:
                    '${label}: ${type} ' +
                    (translations ? translations['b2b.form.invalid'] : ''),
                  date:
                    '${label}: ${type} ' +
                    (translations ? translations['b2b.form.invalid'] : ''),
                  method:
                    '${label}: ${type} ' +
                    (translations ? translations['b2b.form.invalid'] : ''),
                  array:
                    '${label}: ${type} ' +
                    (translations ? translations['b2b.form.invalid'] : ''),
                  object:
                    '${label}: ${type} ' +
                    (translations ? translations['b2b.form.invalid'] : ''),
                  boolean:
                    '${label}: ${type} ' +
                    (translations ? translations['b2b.form.invalid'] : ''),
                  integer:
                    '${label}: ${type} ' +
                    (translations ? translations['b2b.form.invalid'] : ''),
                  float:
                    '${label}: ${type} ' +
                    (translations ? translations['b2b.form.invalid'] : ''),
                  regexp:
                    '${label}: ${type} ' +
                    (translations ? translations['b2b.form.invalid'] : ''),
                  url:
                    '${label}: ${type} ' +
                    (translations ? translations['b2b.form.invalid'] : ''),
                  hex:
                    '${label}: ${type} ' +
                    (translations ? translations['b2b.form.invalid'] : ''),
                },
                number: {
                  len: '${label} must equal ${len}',
                  min: '${label} cannot be less than ${min}',
                  max: '${label} cannot be greater than ${max}',
                  range: '${label} must be between ${min} and ${max}',
                },
                array: {
                  len: '${label} must be exactly ${len} in length',
                  min: '${label} cannot be less than ${min} in length',
                  max: '${label} cannot be greater than ${max} in length',
                  range: '${label} must be between ${min} and ${max} in length',
                },
                pattern: {
                  mismatch: '${label} does not match pattern ${pattern}',
                },
                enum: '${label} must be one of [${enum}]',
                whitespace: '${label} cannot be empty',
                date: {
                  format: '${label} is invalid for format date',
                  parse: '${label} could not be parsed as date',
                  invalid: '${label} is invalid date',
                },
              }}
            >
              <div className="row">
                <div className="col-xl-8">
                  <div className="checkOutInfo">
                    {/* Thông tin xuất hóa đơn */}
                    <HeaderContainer style={{ justifyContent: 'start' }}>
                      <Title>
                        {translations
                          ? translations['b2b.txt.invoice-export-title']
                          : ''}
                      </Title>
                    </HeaderContainer>
                    <Description style={{ fontStyle: 'italic' }}>
                      {translations
                        ? translations['b2b.txt.invoice-export-description']
                        : ''}
                    </Description>
                    <FormContainer
                      style={
                        device === 'mobile'
                          ? {
                              display: 'block',
                            }
                          : {}
                      }
                    >
                      <Form.Item
                        style={
                          device === 'mobile'
                            ? {
                                marginBottom: '8px',
                              }
                            : {}
                        }
                      >
                        <CustomInput
                          placeholder={translations?.['b2b.txt.invoice-code']}
                          disabled
                          value={businessPartner?.extraInfo?.taxNumber}
                        />
                      </Form.Item>
                      <Form.Item
                        style={
                          device === 'mobile'
                            ? {
                                marginBottom: '8px',
                              }
                            : {}
                        }
                      >
                        <CustomInput
                          placeholder={
                            translations?.['b2b.txt.stateBudgetRelatedUnitCode']
                          }
                          disabled
                          value={businessPartner?.extraInfo?.stateBudget}
                        />
                      </Form.Item>
                      <Form.Item
                        style={
                          device === 'mobile'
                            ? {
                                marginBottom: '8px',
                              }
                            : {}
                        }
                      >
                        <CustomInput
                          placeholder={
                            translations?.['b2b.txt.invoice-export-title']
                          }
                          disabled
                          value={businessPartner?.baseInfo?.name}
                        />
                      </Form.Item>
                      <Form.Item
                        style={
                          device === 'mobile'
                            ? {
                                marginBottom: '8px',
                              }
                            : {}
                        }
                      >
                        <CustomInput
                          placeholder={translations?.['b2b.form.address']}
                          disabled
                          value={businessPartner?.baseInfo?.address}
                        />
                      </Form.Item>

                      {/* Emails */}
                      <Form.List name="emails">
                        {(fields, { add, remove }) => (
                          <>
                            {fields.map((field, index) => {
                              const isInitialEmail =
                                currentEmails && !!currentEmails[index];

                              return (
                                <div
                                  key={field.key}
                                  style={{ display: 'flex' }}
                                >
                                  <Form.Item
                                    {...field}
                                    rules={
                                      !isInitialEmail
                                        ? [{ required: true, type: 'email' }]
                                        : []
                                    }
                                    style={
                                      device === 'mobile'
                                        ? {
                                            marginBottom: '8px',
                                            flex: 1,
                                          }
                                        : { flex: 1 }
                                    }
                                    className="form-item-class"
                                    label={translations?.['b2b.acc.email']}
                                  >
                                    <CustomInput
                                      disabled={isInitialEmail}
                                      placeholderCustom={
                                        translations?.['b2b.acc.email']
                                      }
                                    />
                                  </Form.Item>
                                  {!isInitialEmail && (
                                    <button
                                      onClick={() => remove(field.name)}
                                      style={{
                                        cursor: 'pointer',
                                        backgroundColor: 'white',
                                        border: 0,
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                      }}
                                    >
                                      <svg
                                        width="20"
                                        height="20"
                                        viewBox="0 0 20 20"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M15.2903 10.2903H5.30345"
                                          stroke="#E92127"
                                          stroke-width="1.5"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                        />
                                      </svg>
                                    </button>
                                  )}
                                </div>
                              );
                            })}
                            <AddFieldContainer
                              style={{
                                gridColumn: 'span 2',
                                lineHeight: '20px',
                              }}
                            >
                              <div onClick={() => add()}>
                                <PlusIcon />{' '}
                                {translations
                                  ? translations[
                                      'b2b.txt.add-invoice-receipt-email'
                                    ]
                                  : ''}
                              </div>
                            </AddFieldContainer>
                          </>
                        )}
                      </Form.List>
                    </FormContainer>

                    {isProxyBuyer && (
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'start',
                          margin: '50px 0px 10px 0px',
                        }}
                      >
                        <HeaderContainer
                          style={{
                            justifyContent: 'start',
                            marginTop: '36px',
                            margin: 0,
                          }}
                        >
                          <Title>
                            {translations
                              ? translations['b2b.txt.ticketReceiptInfo']
                              : ''}
                          </Title>
                        </HeaderContainer>

                        <Row
                          style={{
                            width: '100%',
                            marginTop: 16,
                          }}
                          gutter={[24, 8]}
                        >
                          <Col span={device === 'mobile' ? 24 : 12}>
                            <Form.Item
                              name={'emailBpAllocatedDebt'}
                              rules={[{ required: true }]}
                              className="form-item-class"
                              label={translations?.['b2b.acc.email'] ?? ''}
                              style={{ marginBottom: 0 }}
                            >
                              <CustomSelect
                                style={{
                                  borderBottom: '1px solid #C1C1C1',
                                  paddingBottom: '7px',
                                }}
                                placeholder={
                                  translations
                                    ? translations['b2b.acc.email'] + '*'
                                    : ''
                                }
                                onBlur={() => {
                                  form.validateFields(['emailBpAllocatedDebt']);
                                }}
                                showSearch
                                filterOption={(input, option) =>
                                  (
                                    convertVItoEN(option?.children) ?? ''
                                  ).includes(convertVItoEN(input))
                                }
                              >
                                {mailReceiveTicketList?.map(item => (
                                  <Option key={item} value={item}>
                                    {item}
                                  </Option>
                                ))}
                              </CustomSelect>
                            </Form.Item>
                          </Col>

                          <Col span={device === 'mobile' ? 24 : 12}>
                            <Form.Item
                              name={'approvedCode'}
                              className="form-item-class"
                              label={translations?.['b2b.acc.email'] ?? ''}
                              style={{ marginBottom: 0 }}
                            >
                              <CustomInput
                                maxLength={190}
                                placeholder={
                                  translations?.['b2b.txt.approvalCode'] ?? ''
                                }
                              />
                            </Form.Item>
                          </Col>

                          <Col span={device === 'mobile' ? 24 : 12}>
                            <Form.Item
                              name={'approveAttach'}
                              className="form-item-class"
                              label={translations?.['b2b.acc.email'] ?? ''}
                              style={{ marginBottom: 0 }}
                            >
                              <StyledUpload
                                beforeUpload={beforeUploadApprovalDocs}
                                action={undefined}
                                multiple={false}
                                maxCount={1}
                              >
                                <Button
                                  style={{ color: '#F8B117', border: 'none' }}
                                >
                                  {translations?.[
                                    'b2b.txt.uploadApprovalDocument'
                                  ] ?? ''}
                                </Button>
                              </StyledUpload>
                            </Form.Item>
                          </Col>
                        </Row>
                      </div>
                    )}

                    {/* Representatives */}
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        margin: '50px 0px 10px 0px',
                      }}
                    >
                      <HeaderContainer
                        style={{
                          justifyContent: 'start',
                          marginTop: '36px',
                          margin: 0,
                        }}
                      >
                        <Title>
                          {translations
                            ? translations['b2b.txt.representiveInfo']
                            : ''}
                        </Title>
                      </HeaderContainer>
                    </div>
                    <Form.List name="representatives">
                      {(fields, { add, remove }) => (
                        <>
                          {fields.map((field, index) => (
                            <div
                              key={field.key}
                              style={{ margin: '20px 0 16px 0px' }}
                            >
                              <p
                                style={{
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  alignItems: 'center',
                                  fontWeight: 600,
                                  fontSize: '16px',
                                }}
                              >
                                {translations
                                  ? translations[
                                      'b2b.txt.contactType.representative'
                                    ]
                                  : ''}{' '}
                                {index + 1}
                                {index !== 0 && (
                                  <button
                                    onClick={() => remove(field.name)}
                                    style={{
                                      cursor: 'pointer',
                                      border: '0px solid #C1C1C1',
                                      borderRadius: '5px',
                                      backgroundColor: 'white',
                                      display: 'flex',
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                    }}
                                  >
                                    <svg
                                      width="20"
                                      height="20"
                                      viewBox="0 0 20 20"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M4 4.83301H5.41667H16.75"
                                        stroke="#E92127"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                      <path
                                        d="M7.53906 4.83333V3.41667C7.53906 3.04094 7.68832 2.68061 7.95399 2.41493C8.21967 2.14926 8.58001 2 8.95573 2H11.7891C12.1648 2 12.5251 2.14926 12.7908 2.41493C13.0565 2.68061 13.2057 3.04094 13.2057 3.41667V4.83333M15.3307 4.83333V14.75C15.3307 15.1257 15.1815 15.4861 14.9158 15.7517C14.6501 16.0174 14.2898 16.1667 13.9141 16.1667H6.83073C6.45501 16.1667 6.09467 16.0174 5.82899 15.7517C5.56332 15.4861 5.41406 15.1257 5.41406 14.75V4.83333H15.3307Z"
                                        stroke="#E92127"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                      <path
                                        d="M8.96094 8.375V12.625"
                                        stroke="#E92127"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                      <path
                                        d="M11.7891 8.375V12.625"
                                        stroke="#E92127"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                    </svg>
                                  </button>
                                )}
                              </p>
                              <FormContainer
                                style={
                                  device === 'mobile'
                                    ? {
                                        display: 'block',
                                      }
                                    : {}
                                }
                              >
                                <Form.Item
                                  {...field}
                                  name={[field.name, 'name']}
                                  rules={[
                                    {
                                      max: 190,
                                      required: requireFields[index],
                                    },
                                  ]}
                                  style={
                                    device === 'mobile'
                                      ? {
                                          marginBottom: '8px',
                                        }
                                      : {}
                                  }
                                  className="form-item-class"
                                  label={
                                    translations?.['b2b.form.namePlaceholder']
                                  }
                                >
                                  <CustomInput
                                    maxLength={190}
                                    placeholder={
                                      translations?.['b2b.form.namePlaceholder']
                                    }
                                  />
                                </Form.Item>
                                <Form.Item
                                  {...field}
                                  name={[field.name, 'phone']}
                                  rules={[
                                    { required: requireFields[index] },
                                    { min: 10 },
                                    { max: 20 },
                                    {
                                      pattern: /^[0-9]+$/g,
                                      message:
                                        translations?.[
                                          'b2b.form.wrongPhoneFormat'
                                        ] ?? '',
                                    },
                                    ({ getFieldValue }) => ({
                                      validator(_, value) {
                                        if (!value) {
                                          return Promise.resolve();
                                        } else {
                                          const phones = getFieldValue(
                                            'representatives',
                                          )
                                            .map((rep: any) => rep.phone)
                                            .filter((phone: string) => !!phone);

                                          const duplicateCount = phones.filter(
                                            (phone: string) => phone === value,
                                          ).length;
                                          if (duplicateCount > 1) {
                                            return Promise.reject(
                                              new Error(
                                                translations?.[
                                                  'b2b.txt.phone-duplicate'
                                                ],
                                              ),
                                            );
                                          }
                                          return Promise.resolve();
                                        }
                                      },
                                    }),
                                  ]}
                                  style={
                                    device === 'mobile'
                                      ? {
                                          marginBottom: '8px',
                                        }
                                      : {}
                                  }
                                  className="form-item-class"
                                  label={translations?.['b2b.acc.phone']}
                                >
                                  <CustomInput
                                    maxLength={20}
                                    onlyNumber
                                    placeholder={
                                      translations?.['b2b.acc.phone']
                                    }
                                  />
                                </Form.Item>
                                <Form.Item
                                  {...field}
                                  name={[field.name, 'email']}
                                  rules={[{ max: 200 }, { type: 'email' }]}
                                  style={
                                    device === 'mobile'
                                      ? {
                                          marginBottom: '8px',
                                        }
                                      : {}
                                  }
                                  className="form-item-class"
                                  label={translations?.['b2b.acc.email']}
                                >
                                  <CustomInput
                                    maxLength={200}
                                    placeholder={
                                      translations?.['b2b.acc.email']
                                    }
                                  />
                                </Form.Item>
                                <Form.Item
                                  {...field}
                                  name={[field.name, 'position']}
                                  rules={[{ required: requireFields[index] }]}
                                  style={
                                    device === 'mobile'
                                      ? {
                                          marginBottom: '8px',
                                        }
                                      : {}
                                  }
                                  className="form-item-class"
                                  label={
                                    translations
                                      ? translations['b2b.txt.position']
                                      : ''
                                  }
                                >
                                  <CustomSelect
                                    style={{
                                      borderBottom: '1px solid #C1C1C1',
                                      paddingBottom: '7px',
                                    }}
                                    placeholder={
                                      translations
                                        ? translations['b2b.txt.position']
                                        : ''
                                    }
                                    onBlur={() => {
                                      form.validateFields([
                                        [
                                          'representatives',
                                          field.name,
                                          'position',
                                        ],
                                      ]);
                                    }}
                                  >
                                    {POSITION.map(item => (
                                      <Option key={item.id} value={item.id}>
                                        {translations?.[item.label]}
                                      </Option>
                                    ))}
                                  </CustomSelect>
                                </Form.Item>
                              </FormContainer>
                            </div>
                          ))}
                          <AddFieldContainer>
                            <div
                              onClick={() =>
                                add({
                                  name: '',
                                  phone: '',
                                  email: '',
                                  position: null,
                                })
                              }
                            >
                              <PlusIcon />{' '}
                              {translations
                                ? translations[
                                    'b2b.txt.add-a-group-representative'
                                  ]
                                : ''}
                            </div>
                          </AddFieldContainer>
                        </>
                      )}
                    </Form.List>
                  </div>
                </div>
                <div className="col-xl-4">
                  <CheckoutOrderOverview
                    isValid={true}
                    listCart={listItems}
                    isSubmitting={isLoading}
                  />
                </div>
              </div>
            </Form>
            <AddonsTicketModal
              open={isShowAddonsModal && shouldShowAddonsModal}
              onClose={() => {
                setIsShowAddonsModal(false);
                setDateAddons(moment().format('YYYY-MM-DD'));
              }}
              listAddons={listAddons}
              handleChangeAddonsAmount={handleChangeAddonsAmount}
              handleAdd={handleAdd}
              isLoading={isAddonsLoading}
              handleChangeDate={handleChangeDate}
              disableSubmit={disableSubmit}
              dateAddons={dateAddons}
            />
          </LoadingContainer>
        </div>
      </div>
    </CheckoutWrapper>
  );
});

export const StyledUpload = styled(Upload)`
  & > .ant-upload {
    border: solid 1px #f8b117;
  }

  .ant-upload-list-item-name {
    font-weight: bold;
    color: #080000;
  }

  .ant-upload-text-icon {
    display: flex;
    .anticon-paper-clip {
      svg {
        fill: #000000;
        transform: scale(1.2);
      }
    }
  }
`;
